import { useVideosComponentContext } from '../../../context';

export function useVideoSteps() {
	const {
		data: { uploadStep },
	} = useVideosComponentContext();

	return { uploadStep };
}
